import { render, staticRenderFns } from "./SingleComment.vue?vue&type=template&id=1de75fec&"
import script from "./SingleComment.vue?vue&type=script&lang=js&"
export * from "./SingleComment.vue?vue&type=script&lang=js&"
import style0 from "./SingleComment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports